import type { FC } from 'react';
import { useCallback, useMemo } from 'react';

import { Logger } from '../../../../logger/Logger';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useSettingsSlice } from '../../../../store/slices/settings/selectors';
import { settingsActions } from '../../../../store/slices/settings/slice';

import { StreamControlPlain } from './StreamControlPlain';

export const StreamControlConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const isInClassicView = useSettingsSlice.getIsInClassicView();
  const isEnabled = useSettingsSlice.getIsStreamEnabled();

  const active = useMemo(() => {
    return !isEnabled || isInClassicView;
  }, [isEnabled, isInClassicView]);

  const handleToggle = useCallback(() => {
    if (active) {
      Logger.logEvent('click', 'classicMode', Date.now(), 1, 'off', false);
      dispatch(settingsActions.setStreamClassicView(false));
    } else {
      Logger.logEvent('click', 'classicMode', Date.now(), 1, 'on', false);
      dispatch(settingsActions.setStreamClassicView(true));
    }
  }, [active, dispatch]);

  return (
    <StreamControlPlain condition={isInClassicView} active={active} onClick={handleToggle} disabled={!isEnabled} />
  );
};
